import { createSlice } from "@reduxjs/toolkit";
import { SELECTED_CITY } from "../../Utils/Constants";


const selectedCity = localStorage.getItem(SELECTED_CITY) !== null ? JSON.parse(localStorage.getItem(SELECTED_CITY)) : { label: "All", value: -1 };


const selectedCitySlice = createSlice({
    name: "selectedCity",
    initialState: {
        selectedCity: selectedCity
    },
    reducers: {
        changeSelectedCity: (state, action) => {
            state.selectedCity = action.payload;
        }
    }
});

export const { changeSelectedCity } = selectedCitySlice.actions;
export default selectedCitySlice.reducer;
